//   (?=.*[0-9])                               should contain at least one digit
//   (?=.*[a-zA-Z])                            should contain at least one lower case in eng or cyrillic symbols
//   (?=.*[!@#$%^&?*])                         should contain at least one special character
//   .{8,}                                     should contain at least 8 characters in length

export const PASSWORD_VALIDATION_PATTERN = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&?*])[a-zA-Z0-9!@#$%^&?*]{8,}$/;
